module.exports = __webpack_public_path__ + "ad868538d1497c954380d9419fc40d19.png";